import { useEffect, useRef } from 'react';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';

export function usePatientLoadTimeTracking(
  patientId: string | undefined,
  { isLoading, isError }: { isLoading: boolean; isError: boolean }
) {
  const { trackEvent } = useAnalytics();
  const trackEventRef = useRef(trackEvent);
  trackEventRef.current = trackEvent;
  const startRef = useRef<{ patientId: string; startedAt: number } | null>(null);

  useEffect(() => {
    if (!patientId) return;
    if (isLoading) {
      if (startRef.current?.patientId !== patientId) {
        startRef.current = { patientId, startedAt: performance.now() };
      }
      return;
    }
    const start = startRef.current;
    if (start?.patientId !== patientId) return;
    startRef.current = null;
    trackEventRef.current(ANALYTICS_EVENTS.PATIENT_DATA_LOADED, {
      durationMs: Math.round(performance.now() - start.startedAt),
      outcome: isError ? 'error' : 'success',
    });
  }, [patientId, isLoading, isError]);
}
